import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-light-svg-icons";

import { fmtCurrency } from "../../utils/helpers";

export default function PaymentTable({ data }) {
	return (
		<div className="receipt" style={{ marginTop: "0" }}>
			<table className="order">
				<thead>
					<tr>
						<th style={{ width: "10%" }}>Qty</th>
						<th className="left">Item</th>
						<th style={{ width: "20%" }}>Amount</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="center">
							<span>1</span>
						</td>
						<td className="payment">
							<div className="flex">
								<div>
									<span style={{ fontWeight: "400" }}>{data.item}</span>
									<small style={{ paddingTop: "3px" }}>
										{data.description}
									</small>
								</div>
							</div>
						</td>
						<td className="right">{fmtCurrency(data.subtotal / 100)}</td>
					</tr>
				</tbody>
				<tfoot>
					{data.fee > 0 && (
						<tr>
							<td colSpan="2" className="right">
								3% Processing Fee
							</td>
							<td className="right">{fmtCurrency(data.fee / 100)}</td>
						</tr>
					)}
					<tr>
						<td colSpan="2" className="right" style={{ paddingTop: "12.5px" }}>
							<span style={{ fontWeight: "400", fontSize: "120%" }}>TOTAL</span>
						</td>
						<td className="right" style={{ paddingTop: "12.5px" }}>
							<span style={{ fontWeight: "400", fontSize: "120%" }}>
								{fmtCurrency(data.total / 100)}
							</span>
						</td>
					</tr>
					{data.paid && (
						<tr>
							<td colSpan="2" className="right">
								{data.paid}
							</td>
							<td className="right">({fmtCurrency(data.total / 100)})</td>
						</tr>
					)}
				</tfoot>
			</table>
		</div>
	);
}
